import { ErrorFallback, IconButton, Modal } from "materia"
import { useTranslation } from "react-i18next"
import s from "./ViewerModalError.module.scss"

export const ViewerModalError = ({
  error,
  onClose,
}: {
  error: unknown
  onClose: () => void
}) => {
  const { t } = useTranslation()
  return (
    <Modal ariaLabel="Viewer load error" overflowAuto={false} onClose={onClose}>
      <div className={s.viewerError}>
        <div className={s.viewerError__closeButton}>
          <IconButton
            as="button"
            className={s.closeButton}
            icon="Close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>
        <div className={s.viewerError__content}>
          <ErrorFallback
            error={error}
            title={t("error.GENERIC")}
            message={t("error.VIEWER_ERROR")}
          />
        </div>
      </div>
    </Modal>
  )
}
